export const REQUEST = 'AUTH_UPDATE_PROFILE_REQUEST';
export const SUCCESS = 'AUTH_UPDATE_PROFILE_SUCCESS';
export const FAILURE = 'AUTH_UPDATE_PROFILE_FAILURE';

export const fetchRequest = (profileData) => ({
  type: REQUEST,
  payload: profileData
});

export const fetchSuccess = (data) => ({
  type: SUCCESS,
  payload: data
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
